import { Grid, makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import Catagory from "../../actions/Catagory";
import UploadImage from "../../actions/uploadImage";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
const initialFValues = {
  name: "",
  description:"",
  image: null,
  editing: false,
};
const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));
const AddMaincatagory = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setCategories,
  edite
}) => {
  useEffect(() => {
    if (recordForEdit != null && edite) {
      setValues({
        ...recordForEdit,
      });
      setfile(recordForEdit.image);
    }
  }, [recordForEdit]);
  const classes = useStyles();
  const { addCatagory, updateCatagory } = Catagory();
  const {uploadImage} = UploadImage();
  const roomImagePicker = useRef(null);
  const [file, setfile] = useState(null);
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("name" in fieldValues)
      temp.name = fieldValues.name.length != 0 ? "" : "This field is required.";
      if ("description" in fieldValues)
      temp.description = fieldValues.description.length !== 0 ? "" : "This field is required.";
      if ("description" in fieldValues) {
        temp.description = 
          fieldValues.description.length >= 4 ? "" : "Description must be at least 4 characters.";
      }

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append(
      "image",
      values.image instanceof File ? values.image : null
    );
    if (validate()) {
      setValues({ ...values, submitting: true });
      if (edite === false) {
        delete values.logginError;
        delete values.editing
        if(values.image === null) {
         delete values.image
        addCatagory(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if(data.category) {
            NotifyMessage({
              message: 'Category successfully created',
              type: "success",
            });
           setOpenPopup(false);
           setCategories(
            produce((draft) => {
              draft.unshift({ ...data.category });
            })
          );
            resetForm();
          }
        });
        }
        else{
        uploadImage(formData,'category').then((data) => {
          if (data.err) {
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if(data.data) {
           values.image = data.data.data
           console.log(values)
        addCatagory(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if(data.category) {
            NotifyMessage({
              message: 'Category successfully created',
              type: "success",
            });
           setOpenPopup(false);
           setCategories(
            produce((draft) => {
              draft.unshift({ ...data.category });
            })
          );
            resetForm();
          }
        });
          }
        });
        }
      } else {
        delete values.logginError;
        delete values.editing
        delete values.image
        updateCatagory({name:values.name,description:values.description}, values.id).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Category successfully updated",
              type: "success",
            });
           setOpenPopup(false);
            resetForm();
            console.log(data.categorie)
            setCategories(
              produce((draft) => {
                const index = draft.findIndex(
                  (category) => category.name === recordForEdit.name
                );
    
                if (index !== -1) draft[index] = data.categorie              
              })
            );
          }
        });
      }
    }
  };
  const firstFieldRef = useRef(null);
    useEffect(() => {
      if (firstFieldRef.current) {
        firstFieldRef.current.focus();
      }
    }, []);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="name"
            label="Name"
            value={values.name}
            onChange={handleInputChange}
            error={errors.name}
            inputRef={firstFieldRef}
          />
           <Controls.Input
            name="description"
            label="Description"
            value={values.description}
            onChange={handleInputChange}
            error={errors.description}
          />
        </Grid>
        <Grid item xs={6}>
          {values.editing == true ? (
            <div className="flex space-x-3 items-center">
              {" "}
              <img className={classes.icon} src={file} alt={file} />
              <Controls.Button
                color="primary"
                onClick={() => {
                  roomImagePicker.current.click();
                }}
                variant="outlined"
                text="Change image"
                className="newButton"
              />
              <input
                label="Icon"
                name="image"
                type="file"
                hidden
                accept="image/*"
                ref={roomImagePicker}
                onChange={handleInputChange}
                autoFocus={true}
              />
            </div>
          ) : (
            <Controls.Input
              name="image"
              type="file"
              label="Image"
              onChange={handleInputChange}
              autoFocus={true}
            />
          )}
        </Grid>
        <Grid item xs>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite == true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
               setOpenPopup(false)
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddMaincatagory;
